export default {"src":"/_next/static/media/1-icon.ca0b7155.svg","height":39,"width":46,"blurWidth":0,"blurHeight":0};